
import BigNumber from 'bignumber.js'

export const safeMax = (...values: (string | number | BigNumber)[]) => {
  const nums = values.map((v) => new BigNumber(v)).filter((v) => v.isFinite()) // убираем NaN, Infinity, -Infinity

  return nums.length ? BigNumber.maximum(...nums) : new BigNumber(NaN)
}
